<template>
  <div class="toolTip">
    <slot class="label-slot"></slot>
    <div class="tips">{{ content }}</div>
  </div>
</template>

<script>
export default {
  name: "index",
  props: {
    content: {
      type: String,
      default: ""
    }
  }
}
</script>

<style lang="scss" scoped>
.toolTip {
  display: inline-block;
  position: relative;
  .tips {
    position: absolute;
  }
}
</style>